"use client";

import { getStoryblokApi } from "~lib/storyblok";

type StoryblokProviderProps = {
  accessToken: string;
  children: React.ReactElement;
};

export default function StoryblokProvider({
  accessToken,
  children,
}: StoryblokProviderProps) {
  getStoryblokApi(accessToken);
  return children;
}
